import React from "react";
import { config, dom } from "@fortawesome/fontawesome-svg-core";

const IconLibrary = () => {
  config.autoAddCss = false;
  // dangerouslySetInnerHTML: as a text child React escapes the quotes in the CSS to
  // &quot;, which a <style> element does not decode. That broke the font-family
  // values and made hydration report a text mismatch on every page.
  return <style dangerouslySetInnerHTML={{ __html: dom.css() }} />;
};

export default IconLibrary;
